import { Container, Form, Button, Card, Modal, Alert, Row, Col } from "react-bootstrap";
import { useState } from "react";
import { 
  downloadParticipantsExcel, 
  uploadAbbinamentiExcel, 
  resetAllData, 
  downloadPartecipantiCostiPDF, 
  downloadTabelloni, 
  partecipantiPDF 
} from '../api/api.js'

export default function Scripts() {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);

  // --- Gestione Tabelloni ---
  const handleDownloadTabelloni = async () => {
    try {
      const blob = await downloadTabelloni();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Tabelloni.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setMessage("File PDF dei tabelloni scaricato con successo.");
      setError(null);
    } catch (e) {
      setError(e.message);
      setMessage(null);
    }
  };

  // --- Gestione PDF Partecipanti (Download e Invio) ---
  const handleDownloadPartecipantiPDF = async () => {
    try {
      const blob = await partecipantiPDF(false);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Report_Partecipanti.zip";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setMessage("File ZIP dei partecipanti scaricato con successo.");
      setError(null);
    } catch (e) {
      setError(e.message);
      setMessage(null);
    }
  };

  const handleSendPartecipantiPDF = async () => {
    setShowEmailModal(false);
    try {
      await partecipantiPDF(true);
      setMessage("PDF inviati con successo a tutte le palestre.");
      console.log("PDF inviati con successo a tutte le palestre.");
      setError(null);
    } catch (e) {
      setError(e.message);
      setMessage(null);
    }
  };

  // --- Gestione Costi e Excel ---
  const handleDownloadCostiPDF = async () => {
    try {
      const blob = await downloadPartecipantiCostiPDF();
      
      // Creazione URL per il download
      const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
      const a = document.createElement("a");
      a.href = url;
      
      // Cambiato da .zip a .pdf per riflettere il nuovo backend
      a.download = `Report_Accettazione.pdf`; 
      
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      
      setMessage("File PDF dell'accettazione scaricato con successo.");
      setError(null);
    } catch (e) {
      setError(e.message);
      setMessage(null);
    }
  };

  const handleDownloadPartecipantiExcel = async () => {
    try {
      const blob = await downloadParticipantsExcel();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Partecipanti.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setMessage("File Excel partecipanti scaricato con successo.");
      setError(null);
    } catch (e) {
      setError(e.message);
      setMessage(null);
    }
  };

  // --- Importazione e Reset ---
  const handleUploadAbbinamenti = () => {
    if (!file) {
      setError("Seleziona un file Excel prima di caricare.");
      return;
    }
    setShowConfirmModal(true);
  };

  const confirmUpload = async () => {
    setShowConfirmModal(false);
    try {
      const res = await uploadAbbinamentiExcel(file);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Errore nell'importazione");
      setMessage("Importazione completata con successo.");
      setError(null);
      setFile(null);
    } catch (e) {
      setError(e.message);
      setMessage(null);
    }
  };

  const confirmReset = async () => {
    setShowResetModal(false);
    try {
      const blob = await resetAllData();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Backup_Pre_Reset.zip";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setMessage("Dati resettati. Backup scaricato con successo.");
      setError(null);
    } catch (e) {
      setError("Errore durante il reset: " + e.message);
      setMessage(null);
    }
  };

  return (
    <Container fluid className="p-4" style={{ maxWidth: "1000px" }}>
      <h2 className="mb-4 text-center fw-bold">Gestione Script Torneo</h2>

      {message && <Alert variant="success" dismissible onClose={() => setMessage(null)}>{message}</Alert>}
      {error && <Alert variant="danger" dismissible onClose={() => setError(null)}>{error}</Alert>}

      <Row>
        {/* Sezione Partecipanti */}
        <Col md={6} className="mb-3">
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <Card.Title className="mb-3">👥 Report Partecipanti</Card.Title>
              <Button onClick={handleDownloadPartecipantiExcel} variant="outline-primary" className="w-100 mb-3">
                Scarica Excel Partecipanti
              </Button>
              <hr />
              <p className="small text-muted mb-2">Gestione PDF per Palestre:</p>
              <Row className="g-2">
                <Col xs={6}>
                  <Button onClick={handleDownloadPartecipantiPDF} variant="primary" className="w-100 h-100">
                    Scarica ZIP
                  </Button>
                </Col>
                <Col xs={6}>
                  <Button onClick={() => setShowEmailModal(true)} variant="success" className="w-100 h-100">
                    Invia Email
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>

        {/* Sezione Torneo e Costi */}
        <Col md={6} className="mb-3">
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <Card.Title className="mb-3">📊 Output Torneo</Card.Title>
              <Button onClick={handleDownloadTabelloni} variant="info" className="w-100 text-white mb-3">
                Scarica PDF Tabelloni
              </Button>
              <Button onClick={handleDownloadCostiPDF} variant="info" className="w-100 text-white mb-3">
                Scarica PDF Accettazione
              </Button>
            </Card.Body>
          </Card>
        </Col>

        {/* Sezione Importazione */}
        <Col md={12} className="mb-3">
          <Card className="shadow-sm">
            <Card.Body>
              <Card.Title className="mb-3">📥 Importazione Abbinamenti</Card.Title>
              <Form.Group controlId="formFile" className="mb-3">
                <Form.Control 
                  type="file" 
                  accept=".xlsx" 
                  onChange={(e) => setFile(e.target.files[0])} 
                />
              </Form.Group>
              <Button variant="primary" onClick={handleUploadAbbinamenti} className="w-100">
                Importa File Excel
              </Button>
            </Card.Body>
          </Card>
        </Col>

        {/* Zona Pericolo */}
        <Col md={12}>
          <Card className="shadow-sm border-danger">
            <Card.Body>
              <Card.Title className="text-danger mb-3">⚠️ Manutenzione</Card.Title>
              <p className="small">Verranno cancellati abbinamenti, aree di gara e status dei match.</p>
              <Button variant="danger" onClick={() => setShowResetModal(true)} className="w-100">
                Reset Totale Dati (con Backup)
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* --- MODALS --- */}

      {/* Modal Invio Email */}
      <Modal show={showEmailModal} onHide={() => setShowEmailModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Conferma Invio Email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Stai per inviare i PDF dei partecipanti a <b>tutte le palestre registrate</b>. 
          Questa operazione invierà email massive. Vuoi continuare?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEmailModal(false)}>Annulla</Button>
          <Button variant="success" onClick={handleSendPartecipantiPDF}>Sì, invia email</Button>
        </Modal.Footer>
      </Modal>

      {/* Altri Modal (Conferma Upload e Reset) */}
      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
        <Modal.Header closeButton><Modal.Title>Conferma Import</Modal.Title></Modal.Header>
        <Modal.Body>Importare gli abbinamenti dal file <strong>{file?.name}</strong>?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>Annulla</Button>
          <Button variant="primary" onClick={confirmUpload}>Conferma</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showResetModal} onHide={() => setShowResetModal(false)} centered>
        <Modal.Header closeButton className="bg-danger text-white"><Modal.Title>Attenzione!</Modal.Title></Modal.Header>
        <Modal.Body>Sei sicuro di voler cancellare TUTTI i dati relativi agli abbinamenti e ai match?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowResetModal(false)}>Annulla</Button>
          <Button variant="danger" onClick={confirmReset}>Conferma Reset</Button>
        </Modal.Footer>
      </Modal>

    </Container>
  );
}